import { fontSizeAdjust } from "./string";

const regexInvalidTags = /<(script|head|body|html|style|form|input|button|noscript|meta|iframe|audio|video|embed|object)(\s+[^>]*>|>)|<\/(script|head|body|html|style|form|input|button|noscript|meta|iframe|audio|video|embed|object)>/gi;
const regexEventHandler = /\son[a-zA-Z]+\s*=\s*("[^"]*"|'[^']*'|[^ >]+)/gi;
const regexJavascript = /\s[src|href]*\s*=\s*('.*(javascript\:|data\:text\/html).*'|".*(javascript\:|data\:text\/html).*")/gi;
const regexElementWithEventHandler = /<([a-zA-Z]+)\b[^>]*\son[a-zA-Z]+\s*=\s*("[^"]*"|'[^']*'|[^ >]+)[^>]*>/gi;

//onerror attribute 기준으로 검사
const prevent = [
	regexInvalidTags,
	regexEventHandler,
	regexJavascript,
];

//onerror attribute가 포함된 태그 전체 제거
export function sanitizeHtml(html) {
	let sanitized = html.replace(regexInvalidTags, '');
	sanitized = sanitized.replace(regexElementWithEventHandler, '');
	sanitized = sanitized.replace(regexJavascript, '');
	sanitized = sanitized.replace(regexEventHandler, '');
	return sanitized;
}

// 기존 콘텐츠에서 onclick 등 이벤트 핸들러만 제거 (태그는 유지)
export function removeEventHandlers(html) {
	if (!html) return html;
	let sanitized = html.replace(regexEventHandler, ''); // onclick 등 이벤트 속성만 제거
	return sanitized;
}

export function validHtml(html: string) {
	return !prevent.some(el => html.toLowerCase().match(el) !== null);
}

export function stringToDom(string:string) {
	return new DOMParser().parseFromString(string, 'text/html').getElementsByTagName('body')[0];
}

export function addBrLine(input:string) {	
	let dom = stringToDom(input);
	dom.querySelectorAll('*').forEach((node:any)=> {
		if ((node.nodeName === 'DIV' || node.nodeName === 'P') && node?.innerText?.length === 0) {
			node.innerHTML = `<br />`;
		}
	})	
	return dom.innerHTML;
}

export function removeHtmlComments(input:string) {
	var res = input.replace(/(<!--.*?-->)|(<!--[\S\s]+?-->)|(<!--[\S\s]*?$)/g, "");
	var res = res.replace(/(<xml>.*?<\/xml>)|(<xml>[\S\s]+?<\/xml>)/g, "");
	return res;
}

export function cleanUpHtml(html:string, type?: string) {
	if (html === null || html === undefined) {
		return '';
	}	
	
	// html 주석 제거
	html = removeHtmlComments(html);

	html = fontSizeAdjust(html);

	let dom = stringToDom(html);
	
	dom.querySelectorAll('*').forEach((node:any)=> {
		// data-* attribute를 갖는 경우 태그를 strip한다. 
		Object.keys(node.dataset).forEach(dataKey => {
			if (dataKey && !dataKey.includes('mce')) {
				let nd = document.createElement('div');
				nd.innerHTML = node.innerHTML;
				node = nd;
			}
		});
		
		// 볼드 마킹
		if (node.style.fontWeight === 'bold' || node.style.fontWeight === '700') {
			if (!node.classList.contains('stb-bold')) {
				node.classList.add('stb-bold');
			}
		}

		// 이탤릭 마킹
		if (node.style.fontStyle === 'italic' || node.style.fontStyle === 'oblique') {
			if (!node.classList.contains('stb-italic')) {
				node.classList.add('stb-italic');
			}
		}

		// 밑줄 마킹
		if (node.style.textDecoration === 'underline') {
			if (!node.classList.contains('stb-underline')) {
				node.classList.add('stb-underline');
			}
		}

		if (node.style.textDecorationLine === 'underline') {
			node.style.textDecoration = 'underline';
			if (!node.classList.contains('stb-underline')) {
				node.classList.add('stb-underline');
			}
		}

		//strike 마킹
		if (node.style.textDecoration === 'line-through') {
			if (!node.classList.contains('stb-line-through')) {
				node.classList.add('stb-line-through');
			}
		}
		
		// font-size: inherit 처리 
		if (node.style.fontSize === 'inherit') {
			node.style.fontSize = '';
		}

		// bold
		if (node.nodeName === 'B' || node.nodeName === 'STRONG') {			
			let nnd = document.createElement('span');
			nnd.innerHTML = node.innerHTML;
			nnd.classList.add('stb-bold');
			nnd.style.fontWeight = 'bold';
			node.parentNode.replaceChild(nnd, node);
		}

		if (node.nodeName === 'U') {			
			let nnd = document.createElement('span');
			nnd.innerHTML = node.innerHTML;
			nnd.classList.add('stb-underline');
			nnd.style.textDecoration = 'underline';
			node.parentNode.replaceChild(nnd, node);
		}

		if (node.nodeName === 'I' || node.nodeName === 'EM') {			
			let nnd = document.createElement('span');
			nnd.innerHTML = node.innerHTML;
			nnd.classList.add('stb-italic');
			nnd.style.fontStyle = 'italic';
			node.parentNode.replaceChild(nnd, node);
		}

		if (node.style.fontFamily.includes('Lato')) {
			node.style.fontFamily = '';
		}
		
		const regHnTag = /H[1-6]/;
		if (node.nodeName.match(regHnTag) !== null) {
			node.style.padding = '0';	
			node.style.margin = '0';
			if (type !== 'htmlcode') node.style.lineHeight = '1.7';

			if (node.innerText.length === 0) {
				node.remove();
			}
		}

	})	
	
	return dom.innerHTML;
}